import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { CRM_DONATIONS_FEATURE_GROUP } from './group';

export const CRM_DONATIONS_FEATURES = {
  READ: {
    guid: 'c7d2e5b8-1a43-4c69-8b27-6e9f1d2a0400',
    name: 'crm_donations:read',
    description: 'View the CRM donations page',
    action: 'read',
    product: 'crm',
    parentGuid: CRM_DONATIONS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { CRM_DONATIONS_FEATURE_GROUP } from './group';

export const CRM_DONATIONS_MODULE: FeatureModule = {
  product: 'crm',
  groups: [CRM_DONATIONS_FEATURE_GROUP],
  features: featureList(CRM_DONATIONS_FEATURES),
};
